import {
    GET_LIST,
    GET_ONE,
    CREATE,
    UPDATE,
    UPDATE_MANY,
    DELETE,
    DELETE_MANY,
    GET_MANY,
    GET_MANY_REFERENCE,
} from 'react-admin';
import {ContentRangeError} from "../errors/content-range-error";

export const API_URL = process.env.NODE_ENV === 'production' ? '/api' : '//localhost:3001/api';

const remapId = ({_id, id, ...other}) => ({ id: (id||_id), _id, ...other});
/**
 * Maps react-admin queries to my REST API
 *
 * @param {string} type Request type, e.g GET_LIST
 * @param {string} resource Resource name, e.g. "posts"
 * @param {Object} payload Request parameters. Depends on the request type
 * @returns {Promise} the Promise for a data response
 */
const vmsDataProvider = (fetch) => (type, resource, params) => {
    let url = '';
    const options = {
        credentials: 'include',
        headers : new Headers({
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }),
    };
    console.log(type, 'params', params);
    switch (type) {

        case DELETE:
            url = `${API_URL}/${resource}/${params.id}`;
            options.method = 'DELETE';
            break;
        case UPDATE:
            url = `${API_URL}/${resource}/${params.id}`;
            options.method = 'PUT';
            options.body = JSON.stringify(params.data);
            break;
        case GET_ONE: url = `${API_URL}/${resource}/${params.id}`; break;
        case CREATE:
            options.method = 'POST';
            url = `${API_URL}/${resource}`;
            options.body = JSON.stringify(params.data);
            break;
        case GET_LIST:
            let filter = params.filter;
            if ( typeof filter !== 'undefined') {

                if (filter && filter.noPoster !== undefined) {
                    delete filter.noPoster;
                    filter.poster = null;
                }

                if (filter && filter.lackOfData !== undefined) {
                    const flag = filter.lackOfData;
                    delete filter.lackOfData;

                    filter = flag ? {$and: [{...filter}, {$or: [{'description': ''}, {imdb_id: null}]}]} : filter;
                }
                if ( filter && filter.is_disabled ) {
                    delete filter.is_disabled;
                    filter.is_enabled = filter.is_enabled ? 42 : false;
                }

                params.filter = filter;
            }
            url = `${API_URL}/${resource}?full&search=${JSON.stringify(params)}`;
            break;
        case GET_MANY:
            console.log("GETMANY REQUEST");
            url=`${API_URL}/${resource}?full&ids=${JSON.stringify(params.ids)}`;
            break;

        case DELETE_MANY:
            url = `${API_URL}/${resource}/bulk`;
            options.body = JSON.stringify({
                ids: params.ids,
                data: {deleted: true, deletedAt: new Date()}
            });
            options.method = 'PUT';
            break;
        case UPDATE_MANY:
            url = `${API_URL}/${resource}/bulk`;
            options.method = 'PUT';
            options.body = JSON.stringify({
                ids: params.ids,
                data: params.data
            });
            break;
        default:
            url = `${API_URL}/${resource}`; break;
            // throw new Error("Unsupported dataprovider action");
    }



    let headers;
    return fetch(url, options)
        .then(res => {
            headers = res.headers;
            return res.json();
        })
        .then(json => {
            switch (type) {
                case GET_ONE:
                    return { data: remapId(json) };
                case GET_LIST:
                case GET_MANY_REFERENCE:
                    if (!headers.has('content-range')) {
                        console.error("no content-range");
                        // throw new ContentRangeError();
                    }
                    const r =  {
                        data: json.map( remapId ), // use slugs for IDS when avail
                        total: parseInt(
                            (headers
                                .get('content-range') || '')
                                .split('/')
                                .pop(),
                            10
                        ),
                    };
                    console.log(type, r);
                    return r;
                case CREATE:
                    return { data: { ...params.data, id: json.id } };
                case UPDATE_MANY:
                case DELETE_MANY:
                    return json;
                default:
                    return { data: json,   total: parseInt(
                            (headers
                                .get('content-range') || '')
                                .split('/')
                                .pop(),
                            10
                        ) };
            }
        });
};


export default vmsDataProvider;
